<template>
  <b-row>
    <b-col cols="12">
      <TagComponent
        :label="$lang.job_experience_work_type"
        category_name="work_time"
        :idTrack="true"
        :requiredLabel="workTypeRequired"
        :parentPermissions="parentPermissions"
        :checkValidation="checkWorkTypeSelected"
        :parentValue="workType"
        @updateCheckValidation="updateCheckWorkTypeSelected"
        @getSelected="getWorkTypeSelected"
      />
    </b-col>
    <b-col cols="12" class="px-4" v-if="showWorkTimeOther">
      <b-form-group
        :label="`${$lang.description} ${$lang.job_experience_work_type} ${$lang.other}`"
        label-for="work_time_other"
        :label-cols="12"
      >
        <requiredComponent
          slot="label"
          :label="`${$lang.description} ${$lang.job_experience_work_type} ${$lang.other}`"
          :rules="$v.work_time_other.$params"
        />
        <b-form-textarea
          type="text"
          autocomplete="off"
          v-model="$v.work_time_other.$model"
          :state="$v.work_time_other.$dirty ? !$v.work_time_other.$error : null"
          rows="4"
        ></b-form-textarea>
        <b-form-invalid-feedback
          :state="$v.work_time_other.$dirty ? !$v.work_time_other.$error : null"
        >
          <div v-if="!$v.work_time_other.required">
            {{
              $lang.error_required
                | replace(
                  `${$lang.description} ${$lang.job_experience_work_type} ${$lang.other}`
                )
            }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <TagComponent
        v-if="checkCustomKey('isJobPlaceByEnumeration', false)"
        :label="$lang.job_experience_company_name"
        category_name="job_place"
        :idTrack="true"
        :requiredLabel="jobPlaceRequired"
        :parentPermissions="parentPermissions"
        :checkValidation="checkJobPlaceSelected"
        :parentValue="jobPlace"
        @updateCheckValidation="updateCheckJobPlaceSelected"
        @getSelected="getJobPlaceSelected"
      />
      <b-form-group
        v-else
        :label="$lang.job_experience_company_name"
        label-for="name_company"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.job_experience_company_name"
          :rules="$v.name_company.$params"
        />
        <b-form-input
          type="text"
          autocomplete="off"
          v-model="$v.name_company.$model"
          :state="$v.name_company.$dirty ? !$v.name_company.$error : null"
        />
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <TagComponent
        v-if="checkCustomKey('isJobPositionByEnumeration', false)"
        :label="$lang.Job_title_position"
        category_name="position"
        :idTrack="true"
        :requiredLabel="jobPositionRequired"
        :parentPermissions="parentPermissions"
        :checkValidation="checkJobPositionSelected"
        :parentValue="jobPosition"
        @updateCheckValidation="updateCheckJobPositionSelected"
        @getSelected="getJobPositionSelected"
      />
      <b-form-group
        v-else
        :label="$lang.Job_title_position"
        label-for="Job_title_position"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.Job_title_position"
          :rules="$v.position.$params"
        />
        <b-form-input
          type="text"
          autocomplete="off"
          v-model="$v.position.$model"
          :state="$v.position.$dirty ? !$v.position.$error : null"
        ></b-form-input>
        <b-form-invalid-feedback
          :style="{ display: $v.position.$error ? 'block' : 'none' }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required | replace($lang.Job_title_position)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <TagComponent
        :label="$lang.job_level"
        category_name="person_company_job_level"
        :idTrack="true"
        :requiredLabel="jobLevelRequired"
        :parentPermissions="parentPermissions"
        :checkValidation="checkJobLevelSelected"
        :parentValue="jobLevel"
        @updateCheckValidation="updateCheckJobLevelSelected"
        @getSelected="getJobLevelSelected"
      />
    </b-col>
    <b-col cols="12">
      <b-form-group
        v-if="checkCustomKey('isWorkExperienceProvince', false)"
        :label="$lang.province"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          v-if="checkCustomKey('isWorkExperienceProvince', false)"
          slot="label"
          :label="$lang.province"
          :rules="$v.provinceSelected.$params"
        />
        <selectFind
          :options="provinceOptions"
          v-model="$v.provinceSelected.$model"
          id="id"
          label="caption"
          :isValid="
            $v.provinceSelected.$dirty ? !$v.provinceSelected.$error : null
          "
          :loading="provinceLoading"
          :placeholder="$lang.search_city"
          @input="getTownshipCombo"
        />
        <b-form-invalid-feedback
          :class="{ 'd-none': $v.provinceSelected.$error }"
        >
          {{ $lang.error_required | replace($lang.province) }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        v-else
        :label="$lang.city_name"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.city_name"
          :rules="$v.location_selected.$params"
        />
        <selectAsync
          :options="location_options"
          v-model="$v.location_selected.$model"
          label="caption"
          :asyncFind="getLocation"
          :isValid="
            $v.location_selected.$dirty ? !$v.location_selected.$error : null
          "
          :loading="location_loading"
          :placeholder="$lang.search_city"
        />
        <b-form-invalid-feedback
          :style="{ display: $v.location_selected.$error ? 'block' : 'none' }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required | replace($lang.city_name)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group
        v-if="showTownship"
        :label="$lang.township"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.township"
          :rules="$v.townshipSelected.$params"
        />
        <selectFind
          :options="townshipOptions"
          v-model="$v.townshipSelected.$model"
          id="id"
          label="caption"
          :isValid="
            $v.townshipSelected.$dirty ? !$v.townshipSelected.$error : null
          "
          :loading="townshipLoading"
          :placeholder="$lang.search_city"
          @input="getTownshipSectionCombo"
        />
        <b-form-invalid-feedback
          :class="{ 'd-none': $v.townshipSelected.$error }"
        >
          {{ $lang.error_required | replace($lang.township) }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group
        v-if="showTownshipSection"
        :label="$lang.townshipSection"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.townshipSection"
          :rules="$v.townshipSectionSelected.$params"
        />
        <selectFind
          :options="townshipSectionOptions"
          v-model="$v.townshipSectionSelected.$model"
          id="id"
          label="caption"
          :isValid="
            $v.townshipSectionSelected.$dirty
              ? !$v.townshipSectionSelected.$error
              : null
          "
          :loading="townshipSectionLoading"
          :placeholder="$lang.search_city"
        />
        <b-form-invalid-feedback
          :class="{ 'd-none': $v.townshipSectionSelected.$error }"
        >
          {{ $lang.error_required | replace($lang.townshipSection) }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group
        :label="$lang.job_experience_start_year_month"
        label-for="from_year_month"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.job_experience_start_year_month"
          :rules="$v.from_year_month.$params"
        />
        <date-picker
          type="year-month"
          v-model="$v.from_year_month.$model"
          display-format="jMMMM jYYYY"
          :state="$v.from_year_month.$dirty ? !$v.from_year_month.$error : null"
          inputReq="true"
          clearable
          :max="new Date() | moment('jYYYY/jMM')"
          :class="
            $v.to_year_month.$dirty
              ? $v.to_year_month.$error
                ? 'invalid-date'
                : 'valid-date'
              : null
          "
        >
        </date-picker>
        <b-form-invalid-feedback
          :style="{ display: $v.from_year_month.$error ? 'block' : 'none' }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required
              | replace($lang.job_experience_start_year_month)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group
        :label="$lang.job_experience_end_year_month"
        label-for="to_year_month"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.job_experience_end_year_month"
          :rules="$v.to_year_month.$params"
        />
        <date-picker
          type="year-month"
          v-model="$v.to_year_month.$model"
          :state="$v.to_year_month.$dirty ? !$v.to_year_month.$error : null"
          inputReq="true"
          display-format="jMMMM jYYYY"
          clearable
          :min="$v.from_year_month.$model | moment('YYYY-MM')"
          :max="new Date() | moment('jYYYY/jMM')"
          :class="
            $v.to_year_month.$dirty
              ? $v.to_year_month.$error
                ? 'invalid-date'
                : 'valid-date'
              : null
          "
        >
        </date-picker>
        <b-form-invalid-feedback
          :style="{ display: $v.to_year_month.$error ? 'block' : 'none' }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required | replace($lang.job_experience_end_year_month)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="checkCustomKey('isWorkExperienceOrganizationType')">
      <b-form-group
        :label="$lang.organization_type"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.organization_type"
          :rules="$v.organization_type_selected.$params"
        />
        <selectFind
          :options="organization_type_options"
          v-model="$v.organization_type_selected.$model"
          label="text"
          :isValid="
            $v.organization_type_selected.$dirty
              ? !$v.organization_type_selected.$error
              : null
          "
          :placeholder="$lang.organization_type"
        />
        <b-form-invalid-feedback
          :style="{
            display: $v.organization_type_selected.$error ? 'block' : 'none',
          }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required | replace($lang.organization_type)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="checkCustomKey('isWorkExperienceJobCategory')">
      <b-form-group
        :label="$lang.job_category"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.job_category"
          :rules="$v.job_category_selected.$params"
        />
        <selectFind
          :options="job_category_options"
          v-model="$v.job_category_selected.$model"
          label="caption"
          :isValid="
            $v.job_category_selected.$dirty
              ? !$v.job_category_selected.$error
              : null
          "
          :placeholder="$lang.job_category"
        />
        <b-form-invalid-feedback
          :style="{
            display: $v.job_category_selected.$error ? 'block' : 'none',
          }"
          id="job_category-feedback"
        >
          {{
            $lang.error_required | replace($lang.job_category)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      v-if="
        checkCustomKey('isWorkExperienceJobCategory') &&
        pathOr(false, ['id'], job_category_selected) === 8
      "
    >
      <b-form-group
        :label="$lang.job_category"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.job_category"
          :rules="$v.job_category_text.$params"
        />
        <b-form-textarea
          id="job_category_text"
          type="text"
          v-model="$v.job_category_text.$model"
          :state="
            $v.job_category_text.$dirty ? !$v.job_category_text.$error : null
          "
          autocomplete="off"
          rows="4"
        >
        </b-form-textarea>
        <b-form-invalid-feedback id="father_name-feedback">
          {{ $lang.error_required | replace($lang.job_category) }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="checkCustomKey('isWorkExperiencePhone')">
      <b-form-group
        :label="$lang.phone"
        label-for="phone"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.phone"
          :rules="$v.phone.$params"
        />
        <b-form-input
          type="text"
          autocomplete="off"
          v-model="$v.phone.$model"
          :state="$v.phone.$dirty ? !$v.phone.$error : null"
        ></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="checkCustomKey('isWorkExperienceAddress')">
      <b-form-group
        :label="$lang.address"
        label-for="address"
        :label-cols="$config.form.labelCol"
      >
        <b-form-input
          type="text"
          v-model="$v.address.$model"
          :state="$v.address.$dirty ? !$v.address.$error : null"
          autocomplete="off"
        ></b-form-input>
      </b-form-group>
      <b-form-invalid-feedback id="father_name-feedback">
        {{ $lang.error_required | replace($lang.address) }}
      </b-form-invalid-feedback>
    </b-col>
    <b-col cols="12" v-if="checkCustomKey('isWorkExperienceCauseSeparation')">
      <b-form-group
        :label="$lang.cause_separation"
        :label-cols="$config.form.labelCol"
      >
        <b-form-textarea
          id="description"
          type="text"
          v-model="$v.description.$model"
          :state="$v.description.$dirty ? !$v.description.$error : null"
          autocomplete="off"
          rows="4"
        >
        </b-form-textarea>
        <b-form-invalid-feedback id="father_name-feedback">
          {{ $lang.error_required | replace($lang.description) }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="checkCustomKey('isWorkExperienceIsLastJob')">
      <b-form-checkbox
        id="checkbox-1"
        v-model="is_last_job"
        value="1"
        unchecked-value="0"
      >
        {{ $lang.last_job_label }}
      </b-form-checkbox>
    </b-col>
    <b-col cols="12" class="float-right mt-3">
      <div slot="footer" class="form-group form-btn">
        <b-button
          type="reset"
          class="mr-2"
          variant="outline-danger"
          @click="cancel"
        >
          <mdicon name="close" size="20" />
          {{ $lang.close }}
        </b-button>
        <b-button
          v-if="isAdmin(parentPermissions)"
          type="submit"
          @click="save"
          variant="success"
        >
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import TagComponent from "@/components/tag/tagComponent.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import {
  renderEumOptions,
  isAdmin,
  checkCustomKey,
  generateApiUrl,
} from "@/shared/utils";
import { provide } from "vue";

export default {
  components: {
    TagComponent,
    datePicker: VuePersianDatetimePicker,
  },
  validations: {
    address: {},
    phone: {
      minLength: minLength(11),
      maxLength: maxLength(11),
    },
    name_company: {
      required: requiredIf(
        () => !checkCustomKey("isJobPlaceByEnumeration", false)
      ),
    },
    organization_type_selected: {
      required: requiredIf(() =>
        checkCustomKey("isWorkExperienceOrganizationType")
      ),
    },
    job_category_selected: {},
    job_category_text: {},
    description: {},
    position: {
      required: requiredIf(
        () => !checkCustomKey("isJobPositionByEnumeration", false)
      ),
    },
    provinceSelected: {
      required: requiredIf(() =>
        checkCustomKey("isWorkExperienceProvince", false)
      ),
    },
    location_selected: {
      required: requiredIf(
        () => !checkCustomKey("isWorkExperienceProvince", false)
      ),
    },
    townshipSelected: {},
    townshipSectionSelected: {},
    from_year_month: {},
    to_year_month: {},
    work_time_other: {},
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      places: [],
      is_last_job: 0,
      location_options: [],
      location_loading: false,
      address: null,
      phone: null,
      name_company: null,
      organization_type_selected: null,
      job_category_selected: null,
      job_category_text: null,
      description: null,
      position: null,
      location_selected: null,
      from_year_month: "",
      to_year_month: "",
      work_time_other: "",
      workTypeRequired: true,
      checkWorkTypeSelected: false,
      workType: null,
      checkJobPlaceSelected: false,
      jobPlace: null,
      checkJobPositionSelected: false,
      jobPosition: null,
      jobLevelRequired: true,
      checkJobLevelSelected: false,
      jobLevel: null,
      provinceSelected: null,
      provinceOptions: [],
      provinceLoading: false,
      townshipSelected: null,
      townshipOptions: [],
      townshipLoading: false,
      townshipSectionSelected: null,
      townshipSectionOptions: [],
      townshipSectionLoading: false,
    };
  },
  computed: {
    organization_type_options() {
      return renderEumOptions("organization_type");
    },
    job_category_options() {
      return [
        {
          id: 1,
          caption: "اداری",
        },
        {
          id: 2,
          caption: "مالی",
        },
        {
          id: 3,
          caption: "فنی و مهندسی",
        },
        {
          id: 4,
          caption: "اجتماعی و فرهنگی",
        },
        {
          id: 5,
          caption: "بهداشتی و درمانی",
        },
        {
          id: 6,
          caption: "آموزشی",
        },
        {
          id: 7,
          caption: "کشاورزی و محیط زیست",
        },
        {
          id: 8,
          caption: "سایر موارد",
        },
      ];
    },
    showWorkTimeOther() {
      return (
        checkCustomKey("isWorkExperienceWorkTimeOther", false) &&
        pathOr(null, ["id"], this.workType) === 4
      );
    },
    jobPlaceRequired() {
      return checkCustomKey("isJobPlaceByEnumeration", false);
    },
    jobPositionRequired() {
      return checkCustomKey("isJobPositionByEnumeration", false);
    },
    showTownship() {
      return (
        checkCustomKey("isWorkExperienceTownship", false) &&
        this.provinceSelected
      );
    },
    showTownshipSection() {
      return (
        checkCustomKey("isWorkExperienceTownshipSection", false) &&
        this.townshipSelected
      );
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetchData(value);
        }
      },
    },
  },
  created() {
    this.getProvinceCombo();
  },
  methods: {
    pathOr,
    isAdmin,
    checkCustomKey,
    generateApiUrl,
    cancel() {
      this.$emit("cancel");
    },
    async getProvinceCombo() {
      this.provinceOptions = [];
      try {
        this.provinceLoading = true;
        const url = generateApiUrl(["profile", "province"]);
        const response = await this.$httpService.get(url);
        this.provinceOptions = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.provinceLoading = false;
      }
    },
    async getTownshipCombo(province) {
      const provinceId = pathOr(null, ["id"], province);
      if (!provinceId) return;
      this.townshipOptions = [];
      try {
        this.townshipLoading = true;
        const url = generateApiUrl(
          ["profile", "province_township"],
          [provinceId]
        );
        const response = await this.$httpService.get(url);
        this.townshipOptions = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.townshipLoading = false;
      }
    },
    async getTownshipSectionCombo(township) {
      const townshipId = pathOr(null, ["id"], township);
      if (!townshipId) return;
      this.townshipSectionOptions = [];
      try {
        this.townshipSectionLoading = true;
        const url = generateApiUrl(
          ["profile", "township_section"],
          [townshipId]
        );
        const response = await this.$httpService.get(url);
        this.townshipSectionOptions = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.townshipSectionLoading = false;
      }
    },
    async getLocation(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.location_options = [];
      }

      try {
        this.location_loading = true;
        const url = `${this.$config.api_url}${this.$config.resources.location}?city=${query}`;
        const response = await this.$httpService.get(url);
        this.location_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.location_loading = false;
      }
    },
    save() {
      this.$v.$touch();
      this.checkWorkTypeSelected = true;
      this.checkJobPlaceSelected = true;
      this.checkJobPositionSelected = true;
      this.checkJobLevelSelected = true;
      if (this.workTypeRequired && !this.workType) return;
      if (this.jobPlaceRequired && !this.jobPlace) return;
      if (this.jobPositionRequired && !this.jobPosition) return;
      if (this.jobLevelRequired && !this.jobLevel) return;

      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }
      const jobCategory =
        pathOr(null, ["id"], this.job_category_selected) === 8
          ? this.job_category_text
          : pathOr(null, ["caption"], this.job_category_selected);
      const payload = {
        organization_type_id: pathOr(
          null,
          ["value"],
          this.organization_type_selected
        ),
        job_category: jobCategory,
        from_year_month: this.from_year_month,
        to_year_month: this.to_year_month,
        description: this.description,
        location_id: pathOr(null, ["id"], this.location_selected),
        address: this.address,
        tel: this.phone,
        is_last_job: checkCustomKey("isWorkExperienceIsLastJob")
          ? this.is_last_job
          : 1,
        work_time_other: this.work_time_other,
        work_time_id: pathOr(null, ["id"], this.workType),
        // get name of enum input for moi project
        job_place_id: pathOr(null, ["id"], this.jobPlace),
        // get name of text input for other project
        name: this.name_company,
        // get position of enum input for moi project
        position_id: pathOr(null, ["id"], this.jobPosition),
        // get position of text input for other project
        position: this.position,
        job_level_id: pathOr(null, ["id"], this.jobLevel),
        // get province of enum input for moi project
        province_id: pathOr(null, ["id"], this.provinceSelected),
        // get township of enum input for moi project
        township_id: pathOr(null, ["id"], this.townshipSelected),
        // get townshipSection of enum input for moi project
        section_id: pathOr(null, ["id"], this.townshipSectionSelected),
      };
      this.$emit("submit", payload);
    },
    async fetchData(item) {
      this.name_company = pathOr(null, ["name"], item);
      this.organization_type_selected = this.organization_type_options.find(
        (x) => x.value === pathOr(null, ["organization_type", "id"], item)
      );
      const jobCategory = pathOr(null, ["job_category"], item);
      const findJobCategory = this.job_category_options.find(
        (x) => x.caption === jobCategory
      );
      this.job_category_selected = null;
      if (jobCategory) {
        if (findJobCategory) {
          this.job_category_selected = findJobCategory;
        } else {
          this.job_category_selected = this.job_category_options.find(
            (item) => item.id === 8
          );
          this.job_category_text = jobCategory;
        }
      }
      if (pathOr(null, ["id"], this.job_category_selected) === 8) {
        this.job_category_text = pathOr(null, ["job_category"], item);
      }
      this.from_year_month = pathOr(null, ["from_year_month"], item);
      this.position = pathOr(null, ["position"], item);
      this.to_year_month = pathOr(null, ["to_year_month"], item);
      this.address = pathOr(null, ["address", "address"], item);
      this.phone = pathOr(null, ["address", "tel"], item);
      this.description = pathOr(null, ["description"], item);
      this.is_last_job = pathOr(null, ["is_last_job"], item);
      this.location_selected = {
        id: pathOr(null, ["address", "location", "id"], item),
        caption: pathOr("", ["address", "location", "full_path"], item),
      };
      this.work_time_other = pathOr("", ["work_time_other"], item);
      this.workType = pathOr(null, ["work_time"], item);
      this.jobPlace = pathOr(null, ["job_place_enum"], item);
      this.jobPosition = pathOr(null, ["position_enum"], item);
      this.jobLevel = pathOr(null, ["job_level"], item);
      this.provinceSelected = pathOr(null, ["province"], item);
      await this.getTownshipCombo(this.provinceSelected);
      this.townshipSelected = pathOr(null, ["township"], item);
      await this.getTownshipSectionCombo(this.townshipSelected);
      this.townshipSectionSelected = pathOr(null, ["section"], item);
    },
    getWorkTypeSelected(data) {
      this.workType = data;
    },
    updateCheckWorkTypeSelected(data) {
      this.checkWorkTypeSelected = data;
    },
    getJobPlaceSelected(data) {
      this.jobPlace = data;
    },
    updateCheckJobPlaceSelected(data) {
      this.checkJobPlaceSelected = data;
    },
    getJobPositionSelected(data) {
      this.jobPosition = data;
    },
    updateCheckJobPositionSelected(data) {
      this.checkJobPositionSelected = data;
    },
    getJobLevelSelected(data) {
      this.jobLevel = data;
    },
    updateCheckJobLevelSelected(data) {
      this.checkJobLevelSelected = data;
    },
  },
};
</script>
